module.exports = __webpack_public_path__ + "media/images/medical-icon-5482ef7e81371a850a801056819b6132.png";